const routes = {
    home: '/',
    appLinks: 'app/:module/:section/:subsection',
    login: 'login',
    passwordRecovery: 'recover-password',
    products: 'products',
    edit: 'edit',
    massiveUpload: 'massive',
    individualUpload: 'individual',
    liquidate: 'liquidate',
    inventory: 'inventory',
    orders: 'orders',
    payment: 'payment',
    posPayment: 'posPayment',
    qr: 'qr',
    successPayment: 'successPayment',
    cashPayment: 'cashPayment',
    sales: 'sales',
    salesDetails: 'details',
    voucherScreen: 'voucherScreen',
    hasVoucherScreen: 'hasVoucherScreen',
    configurations: 'configurations',
    ecofriendSurvey: 'ecoFriendSurvey',
    ecofriendCommerce: 'ecoFriendCommerce',
    storeConfigurations: 'store-configurations',
    scheduled: 'scheduled',
    onlineStoreInformationScreen: 'onlineStoreInformationScreen',
    optionOnlineStore: 'optionOnlineStoreScreen',
    scheduledOnlineStore: 'scheduledPurchaseOnlineStoreScreen',
    termsAndConditions: 'TermsAndConditions',
    onlineStoreActivated: 'onlineStoreActivated',
    urlDashboard: 'reportes',
    chat: 'chat',
    bci: 'bci',
    getnet: 'getnet',
    billing: 'facturacion',
    requestProforma: 'proforma',
    calendar: 'calendar',
    communication: 'communication',
    subscription: 'subscription',
    subscriptionDetail: 'subscriptionDetail',
    createPromotion: 'createPromotion',
    createPromotionDate: 'createPromotionDate',
    promotionCreated: 'promotionCreated',
    promotions: 'promotions',
    promotionMain: 'promotionMain',
    billingMain: 'billingMain',
    billingDocument: 'billingDocument',
    billingDocumentExtended: 'billingDocumentExtended',
    storeProfileMain: 'storeProfileMain',
    storeMain: 'storeMain',
    localMain: 'localMain',
    payProforma: 'payProforma',
    impulsa: 'impulsa',
    cart: 'cart',
    myPlan: 'miPlan',
    report: 'report',
    changePass: 'changePass',
}

export default routes
